import { render, staticRenderFns } from "./RepeaterTherapies.vue?vue&type=template&id=7366130f&"
import script from "./RepeaterTherapies.vue?vue&type=script&lang=js&"
export * from "./RepeaterTherapies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports